import './Placeholder.sass';

import React, { FC } from 'react';
import { PlaceholderProps } from './Placeholder.interface';
import { classNames } from '$utils';

export const Placeholder: FC<PlaceholderProps> = ({
  title = '',
  icon = null,
  actions = null,
  children,
  centered = false,
  iconSize = 56,
  note = null,
  className,
  compact = false,
}) => {
  return (
    <div className={classNames('Placeholder', className, { centered, compact })}>
      {icon && (
        <div className="Placeholder__icon" style={{ width: iconSize, height: iconSize }}>
          {icon}
        </div>
      )}
      {title && <div className="Placeholder__title">{title}</div>}
      {!!children && <div className="Placeholder__text">{children}</div>}
      {actions && <div className="Placeholder__actions">{actions}</div>}
      {note && <div className="Placeholder__note">{note}</div>}
    </div>
  );
};
